export type EdgePoolError = Readonly<{
  errorCode: EdgePoolErrorCode;
  errorMessage: string;
}>;

export enum EdgePoolErrorCode {
  POOL_ID_DOES_NOT_EXIST = 'EDGE_POOL_ADMIN_POOL_ID_DOES_NOT_EXIST',
  UNKNOWN_ERROR = 'EDGE_POOL_ADMIN_UNKNOWN_ERROR',
  NO_RESPONSE_FROM_RAS_OR_EPRS = 'EDGE_POOL_ADMIN_NO_RESPONSE_FROM_RAS_OR_EPRS',
  PARTIAL_DELETION = 'EDGE_POOL_ADMIN_PARTIAL_DELETION',
  INVALID_CHANGE_TYPE = 'EDGE_POOL_ADMIN_INVALID_CHANGE_TYPE',
  AGENT_ID_DOES_NOT_EXIST = 'EDGE_POOL_ADMIN_AGENT_ID_DOES_NOT_EXIST',
}
